import React, { useState } from "react";
import {
  Box,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { AssignmentOutlined, CheckCircle } from "@mui/icons-material";
import { capitalCase } from "change-case";
import ActionForm from "./ActionForm";
import MenuAction from "./MenuAction";
import { updateAction } from "../../../Config/db/actions.retrieve";
import { isZeroEstimate } from "./useConsolidatedActions";

const STATUS_COLOR = {
  done: "success",
  "in-progress": "warning",
  open: "info",
  blocked: "error",
};

/* Cycle through statuses on click: open → in-progress → done */
const NEXT_STATUS = {
  open: "in-progress",
  "in-progress": "done",
  done: "open",
  blocked: "open",
};

export default function Actions({ actions }) {
  const [fieldPicked, setFieldPicked] = useState("");
  const [editForm, setEditForm] = useState(false);
  const [populdateData, setPopulateData] = useState({});

  const handleClose = () => {
    setEditForm(false);
    setFieldPicked("");
    setPopulateData({});
  };

  if (!actions.length) {
    return (
      <Box sx={{ textAlign: "center", py: 4 }}>
        <AssignmentOutlined sx={{ fontSize: 48, color: "text.disabled", mb: 1 }} />
        <Typography color="text.secondary">No actions found</Typography>
      </Box>
    );
  }

  return (
    <Paper elevation={0} sx={{ borderRadius: 2, border: "1px solid #e0e0e0", overflow: "hidden" }}>
      <ActionForm
        open={editForm}
        fieldPicked={fieldPicked}
        handleClose={handleClose}
        populdateData={populdateData}
      />
      <TableContainer sx={{ overflowX: "auto" }}>
        <Table size="small" sx={{ minWidth: 480 }}>
          <TableHead>
            <TableRow sx={{ bgcolor: "#f5f5f5" }}>
              <TableCell sx={{ fontWeight: 700, color: "#1a237e" }}>Task</TableCell>
              <TableCell sx={{ fontWeight: 700, color: "#1a237e", display: { xs: "none", sm: "table-cell" } }}>Estimate</TableCell>
              <TableCell sx={{ fontWeight: 700, color: "#1a237e" }}>Status</TableCell>
              <TableCell sx={{ fontWeight: 700, color: "#1a237e", display: { xs: "none", sm: "table-cell" } }}>Assignee</TableCell>
              <TableCell sx={{ fontWeight: 700, color: "#1a237e" }} align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {actions.map((action) => {
              const { taskName, status, estimate } = action;
              return (
                <TableRow
                  key={action.id}
                  sx={{ "&:hover": { bgcolor: "#fafafa" } }}
                >
                  <TableCell>
                    <Typography variant="body2" fontWeight={500}>
                      {taskName}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ display: { xs: "none", sm: "table-cell" } }}>
                    <Chip size="small" label={isZeroEstimate(estimate) ? "Unestimated" : estimate} variant="outlined" sx={isZeroEstimate(estimate) ? { color: "text.disabled", borderColor: "#e0e0e0" } : {}} />
                  </TableCell>
                  <TableCell>
                    <Chip
                      size="small"
                      label={capitalCase(status)}
                      color={STATUS_COLOR[status] || "default"}
                      icon={status === "done" ? <CheckCircle sx={{ fontSize: 14 }} /> : undefined}
                      onClick={() => {
                        const next = NEXT_STATUS[status] || "open";
                        updateAction(action.id, { status: next });
                      }}
                      sx={{ cursor: "pointer", fontWeight: 600 }}
                    />
                  </TableCell>
                  <TableCell sx={{ display: { xs: "none", sm: "table-cell" } }}>
                    <Typography variant="body2" color={action.assigneeName ? "text.primary" : "text.disabled"} fontWeight={action.assigneeName ? 500 : 400}>
                      {action.assigneeName || "Unassigned"}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <MenuAction
                      setEditForm={setEditForm}
                      setFieldPicked={setFieldPicked}
                      setPopulateData={() => setPopulateData(action)}
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
